import round from 'lodash/fp/round';

export const percent = (value, total) => round((value / total) * 100, 1);

export const green = '#58ED93';
export const red = '#F94D35';
export const grey = '#DEDEDE';
